<template>
  <div :class="['left-container', !printDesign && 'backgroundImg']">
    <div class="flex-container">
      <div class="event-title">
        {{ eventInfo.eventTitle }}
      </div>
      <div class="qr-code-container">
        <canvas v-if="!hidePrice" ref="qrcode" class="qrcode" :style="{ margin: 0, padding: 0 }" />
        <div class="qr-code-ticket-id-container">
          Ticked ID Nº <br />
          {{ getTicketId }}
        </div>
      </div>
    </div>
    <div class="event-date-and-price-container">
      <div class="event-date-container">
        <div class="event-date">{{ eventInfo.eventDate }}</div>
        <p class="event-address">{{ eventInfo.eventAddress }}</p>
      </div>

      <div class="price-and-fee-container">
        <div v-if="!hidePrice" class="price-container">
          Cijena:
          <strong>{{ totalPriceRounded.toFixed(2) }} EUR</strong>, Osnovica:
          {{ totalPriceRounded ? (totalPriceRounded / (1 + getTicketVAT / 100)).toFixed(2) : '' }}
          EUR, PDV ({{ getTicketVAT }}%):
          {{ (totalPriceRounded - totalPriceRounded / (1 + getTicketVAT / 100)).toFixed(2) }}
          EUR*
        </div>
        <p v-if="Number(ticketSellerOrganization.id) !== 1" class="fee-container">
          Naknada za izdavanje ulaznice: {{ getCoreEventFeeWithoutVat() * 1.25 }} EUR, Osnovica:
          {{ getCoreEventFeeWithoutVat().toFixed(2) }} EUR, PDV (25%):
          {{ round(getCoreEventFeeWithoutVat() * 1.25 - getCoreEventFeeWithoutVat(), 2) }} EUR
        </p>
      </div>
    </div>
    <div class="ticket-info-container">
      <div v-if="ticketLocation && ticketLocationDto" class="ticket-location-container">
        <div
          v-for="(location, index) in ticketLocationDto"
          :key="index"
          class="ticket-location-field-container"
        >
          <div class="ticket-location-field-left">{{ index }}</div>
          <div class="ticket-location-field-right">
            <strong>{{ location }}</strong>
          </div>
        </div>
      </div>
      <div class="ticket-name-container">
        <div class="ticket-name">
          <div
            :style="{ fontSize: '10px', color: 'grey', margin: 0, lineHeight: '12px', padding: 0 }"
          >
            Naziv ulaznice
          </div>
          <strong
            :style="{ fontSize: '12px', color: 'black', margin: 0, lineHeight: '14px', padding: 0 }"
            >{{ ticketName }}</strong
          >
        </div>
        <div class="ticket-seller-container">
          <div v-if="!hidePrice">
            <div>{{ $t('purchasedIn') }}: {{ sellerName }}</div>
            <div>
              {{ $t('invoiceNumber') }}: {{ fiscalisationInfo.invoiceId }}, {{ $t('released') }}:
              {{ purchaseDate }}
            </div>
            <div v-if="!isCustomFiscalisation">
              {{ $t('issuedInTheName') }}: CoreEvent,<br />
              Dunjevac 15, 10000 Zagreb, Hrvatska<br />{{ $t('vat') }}: 36611335369
            </div>
            <div v-if="isCustomFiscalisation">
              {{ ticketSellerOrganization.name }},<br />
              {{ ticketSellerOrganization.address }}, {{ organization.postalCode }}
              {{ organization.city }}<br />{{ $t('vat') }}:
              {{ ticketSellerOrganization.oib }}
            </div>
            <div>{{ $t('order') }} #100{{ orderNumber }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { exchangeRate } from '../../../src/utils'
import moment from 'moment'
import i18next from 'i18next'
import { round } from 'lodash'
import { PaymentType } from '@/enums/payment-type.js'
import { OrganizationCustomTicketFee } from '@/types'

export default {
  name: 'pdf-ticket-left',
  props: [
    'hasBottomBorder',
    'eventInfo',
    'ticketLocation',
    'buyer',
    'ticketName',
    'ticketPrice',
    'sellerName',
    'isCustomFiscalisation',
    'ticketSellerOrganization',
    'orderNumber',
    'purchasedAt',
    'fiscalisationInfo',
    'organization',
    'printDesign',
    'hidePrice',
    'qrcode',
    'ticketsInfo',
    'ticketIndex',
  ],
  data() {
    return {
      exchangeRate: exchangeRate,
      purchaseDate: `${moment(this.purchasedAt).format('D.M.YYYY., HH:mm')}h`,
      totalPriceRounded: null,
      ticketLocationDto: null,
      coreEventFeePerTicketWithoutVat: null,
    }
  },
  computed: {
    isTableTicket() {
      return this.ticketsInfo[this.ticketIndex].orderItem.itemMeta.table
    },
    isParterTicket() {
      return this.ticketsInfo[this.ticketIndex].orderItem.itemMeta.parter
    },
    getTicketId() {
      return this.ticketsInfo[this.ticketIndex].accreditation.id || ''
    },
    getTicketVAT() {
      return Number(this.ticketsInfo[this.ticketIndex].orderItem.id) === 9963
        ? 25
        : this.organization.VATPercentage
    },
  },
  async mounted() {
    this.generateQrCode(this.qrcode)
    this.roundTotalPrice(this.ticketPrice)
    if (this.ticketLocation && !this.isParterTicket) {
      this.setTicketLocation(this.ticketLocation)
    }
  },
  methods: {
    round,
    setTicketLocation(ticketLocation) {
      const language = i18next.language
      let ticketLocationArray = ticketLocation.split('_')
      this.ticketLocationDto = {}

      ticketLocationArray.forEach(item => {
        let [key, ...value] = item.split('-')

        if (language !== 'en') {
          if (key === 'Seat') key = this.isTableTicket ? 'Stol' : 'Sjedalo'
          if (key === 'Row') key = 'Red'
          if (key === 'Section') key = 'Sektor'
        } else {
          if (key === 'Seat') key = this.isTableTicket ? 'Table' : key
        }

        this.ticketLocationDto[key] = value.join('-')
      })
    },
    getCoreEventFeeWithoutVat() {
      return this.ticketSellerOrganization.fees.useEventFeePerTicket
        ? this.getFixedFeeForSelectedTicket(this.ticketPrice)
        : 0
    },
    getFixedFeeForSelectedTicket(ticketPrice) {
      let ticketFee = this.eventInfo.fixedFeePerTicket || this.organization.fixedFeePerTicket || 0
      const customOrganizationFees = OrganizationCustomTicketFee[Number(this.organization.id)]
      if (customOrganizationFees) {
        ticketFee = this.getTicketFee(ticketPrice, customOrganizationFees)
      }

      return ticketFee
    },
    getTicketFee(price, organizationFees) {
      let ticketFee = 0
      for (const key in organizationFees) {
        const ranges = organizationFees[key]
        if (price >= ranges.min && price <= ranges.max) {
          return (ticketFee = Number(key))
        }
      }

      return ticketFee
    },
    roundTotalPrice(price) {
      const paymentType = (this.buyer && this.buyer.paymentType) || null
      let ticketPrice = Number(price)

      if (!paymentType) {
        return (this.totalPriceRounded = round(ticketPrice, 2))
      }

      if (paymentType === PaymentType.KEKS10) {
        ticketPrice = ticketPrice * 0.9
      } else if (paymentType === PaymentType.TELEGRAM20) {
        ticketPrice = ticketPrice * 0.8
      } else if (paymentType === PaymentType.FREE) {
        ticketPrice = 0
      }

      return (this.totalPriceRounded = round(ticketPrice, 2))
    },
    async generateQrCode(value) {
      const canvas = this.$refs.qrcode

      return QRCode.toCanvas(canvas, value, {
        width: 65,
        margin: 0,
      })
    },
  },
}
</script>

<style scoped>
.left-container {
  height: 100%;
  width: calc(210mm * 0.8);
  padding: 5mm 0 0 6mm;
}

.backgroundImg {
  background-image: url('../../../public/assets/ticket-background.svg');
  background-size: cover;
}

.event-title {
  flex: 1 0 0;
  font-size: 22px;
  line-height: 24px;
  font-weight: 600;
}

.flex-container {
  display: flex;
}

.qr-code-container {
  text-align: center;
  width: 100px;
}

.qrcode {
  margin-top: 1mm;
  margin-right: 20px;
  height: 13mm !important;
  width: 13mm !important;
}

.qr-code-ticket-id-container {
  margin-top: 2px;
  font-size: 10px;
  color: #333333;
}

.event-date-and-price-container {
  display: flex;
  width: 100%;
  margin-top: 10px;
}

.event-date-container {
  flex: 1 0 0;
  border-left: 1px solid black;
  padding-left: 10px;
}

.ticket-location-container {
  font-size: 10px;
  color: #333333;
  display: flex;
  gap: 5px;
  flex: 1 0 0;
}

.ticket-location-field-container {
  border-left: 1px solid black;
  padding-left: 10px;
  flex: 1 0 0;
}

.ticket-location-field-left {
  font-size: 10px;
  color: #333333;
  margin: 0;
  padding: 0;
  line-height: 12px;
}

.ticket-location-field-right {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0;
  line-height: 14px;
}

.event-date {
  font-size: 12px;
  font-weight: 600;
}

.event-address {
  font-size: 10px;
  color: #333333;
}

.price-and-fee-container {
  flex: 1 0 0;
  border-left: 1px solid black;
  padding-left: 10px;
}

.price-container {
  font-size: 12px;
}

.fee-container {
  font-size: 10px;
  color: grey;
  margin: 5px 0 0 0;
}

.ticket-info-container {
  display: flex;
  width: 100%;
  margin-top: 10px;
}

.ticket-name-container {
  display: flex;
  flex: 1 0 0;
  margin-right: 5px;
}

.ticket-name {
  border-left: 1px solid black;
  padding-left: 10px;
  flex: 1 0 0;
}

.ticket-seller-container {
  font-size: 6px;
  text-align: right;
  line-height: 8px;
}
</style>
